// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"65484b2b","1117":"0115e690","3264":"e6c2063f","9243":"9e8b91ce"}[chunkId] + ".chunk.css";
};